import React, { useCallback, useState } from 'react';
import { Link } from '@inertiajs/react';
import { Button } from '../../components/ui/button';
import { useTrans } from '../../hooks/useTrans';
import { copyToClipboard } from '../../lib/clipboard';
import AuthCard from '../../components/layout/auth/AuthCard';

export default function AuthenticatorComplete({ recoveryCodes }) {
    const translate = useTrans();
    const [copyText, setCopyText] = useState(translate('Kopiëren'));

    const getCodesText = useCallback(() => {
        return recoveryCodes.map((code) => code.code).join('\n');
    }, [recoveryCodes]);

    function handleCopy(e) {
        e.preventDefault();
        copyToClipboard(getCodesText());
        setCopyText(translate('Gekopieerd!'));
        setTimeout(() => setCopyText(translate('Kopiëren')), 2000);
    }

    function handleDownload(e) {
        e.preventDefault();
        const codes = getCodesText();
        const blob = new Blob([codes], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'recovery-codes.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return (
        <AuthCard title={translate('Stap 3: Koppeling geslaagd!')} backLink="/login">
            <p>{translate('Vanaf nu vragen we je bij het inloggen om een extra verificatiecode uit je authenticator-app. Dit zorgt voor extra veiligheid van je account.')}</p>

            <p className="mt-3">{translate('We hebben automatisch herstelcodes voor je aangemaakt. Deze codes kun je gebruiken als je geen toegang hebt tot je authenticator-app.')}</p>

            <p className="mt-3">{translate('Download of kopieer deze herstelcodes en bewaar ze op een veilige plek.')}</p>

            <div className="flex justify-center gap-4 my-4">
                <div className="flex flex-col gap-2">
                    {recoveryCodes.slice(0, 5).map((code, index) => (
                        <div key={index} className="rounded-sm bg-[#f0f0f0] px-2 py-1 font-mono text-sm text-center">
                            {code.code}
                        </div>
                    ))}
                </div>
                <div className="flex flex-col gap-2">
                    {recoveryCodes.slice(5, 10).map((code, index) => (
                        <div key={index} className="rounded-sm bg-[#f0f0f0] px-2 py-1 font-mono text-sm text-center">
                            {code.code}
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex gap-2 mb-4">
                <Button variant="clear" onClick={handleCopy} className="flex-1 text-xs h-9">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M3.33333 10H2.66667C2.31305 10 1.97391 9.85953 1.72386 9.60948C1.47381 9.35943 1.33334 9.0203 1.33334 8.66667V2.66667C1.33334 2.31305 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31305 1.33334 2.66667 1.33334H8.66667C9.0203 1.33334 9.35943 1.47381 9.60948 1.72386C9.85953 1.97391 10 2.31305 10 2.66667V3.33334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {copyText}
                </Button>
                <Button variant="clear" onClick={handleDownload} className="flex-1 text-xs h-9">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 10v2.667A1.334 1.334 0 0112.667 14H3.333A1.334 1.334 0 012 12.667V10M4.667 6.667L8 10l3.333-3.333M8 10V2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {translate('Downloaden')}
                </Button>
            </div>

            <Button variant="primary" asChild className="w-full">
                <Link href="/">{translate('Ga naar dashboard')}</Link>
            </Button>
        </AuthCard>
    );
}
